export default "__VITE_ASSET__CMzQEUcs__"